import { Flex } from "@chakra-ui/react";
import { useAtom } from "jotai";
import { ReactElement, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginErrorModal } from "../../components/molecules/LoginErrorModal";
import { accessTokenInfoAtom, employeeInfoAtom } from "../../store";
import { LoginErrorCode, LoginMethod } from "../../types";
import { useSetSetting } from "../../utils/setting";
import { useGetAccessToken } from "../../utils/token";
import { useDefaultPath } from "../../hooks/useDefaultPath";

export function TwooCaCallback(): ReactElement {
  const [employeeInfo] = useAtom(employeeInfoAtom);
  const location = useLocation();
  const navigate = useNavigate();
  const defaultPath = useDefaultPath();

  // コールバック時に一度だけ実行するためにsetter系の処理をrefで取得
  const [, setAccessTokenInfo] = useAtom(accessTokenInfoAtom);
  const getAccessToken = useRef(useGetAccessToken());
  const setSettingInfo = useRef(useSetSetting());

  const [hasLoginError, setHasLoginError] = useState(false);
  const [errorCode, setErrorCode] = useState<LoginErrorCode | null>(null);
  const onInvalidUserInfo = (errorCode: LoginErrorCode): void => {
    setErrorCode(errorCode);
    setHasLoginError(true);
  };
  const closeErrorModal = (): void => {
    setHasLoginError(false);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const authCode = queryParams.get("code") ?? "";

    getAccessToken
      .current(LoginMethod.TwoocaAuth, onInvalidUserInfo, {
        code: authCode,
      })
      .then(async (response) => {
        if (!response) {
          // APIエラー時はトップ画面に飛ばす
          navigate("/", { replace: true });
          return;
        }

        // FIXME: Core API に TwooCa ログイン連携が未実装のため暫定対応。
        setAccessTokenInfo(response);
        setSettingInfo.current(response);
      })
      .catch((err) => {
        // 想定外のエラー
        console.error(err);
        onInvalidUserInfo("INVALID_TWOOCA_TOKEN");
        navigate("/404", { replace: true });
      });
  }, [
    getAccessToken,
    setSettingInfo,
    setAccessTokenInfo,
    location.search,
    navigate,
  ]);

  useEffect(() => {
    if (employeeInfo.id != "") {
      // 認証コードを履歴に残さないようURLをreplaceする
      navigate(defaultPath, { replace: true });
    }
  }, [navigate, employeeInfo, defaultPath]);

  return (
    <Flex>
      <LoginErrorModal
        isOpen={hasLoginError}
        errorCode={errorCode}
        onClose={closeErrorModal}
      />
    </Flex>
  );
}
